var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"clearfix\"><span class=\"pull-left text-muted {{::$ctrl.labelClass}}\">{{::$ctrl.label}}</span> <strong class=\"pull-right text-right {{::$ctrl.valueClass}}\">{{$ctrl.value||'-'}}</strong></div>";
var id1="labeled-value.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;